export function personMobNav() {
    let navItems = $(".person-nav-item");
    // let headerHeight = $(".header").height();
    let headerHeight = 70;
    let indent = 20;
    let dataPersonAttr = "data-person";
    let $personInfoBlocks = $(".person-info");
    let maxHeight = 0;

    navItems.on("click", function (e) {
        e.preventDefault();
        let id = $(this).attr("data-person-nav");
        let distance = $("["+ dataPersonAttr +"= "+ id +"]").offset().top - headerHeight - indent;

        setTimeout(() => {
            $("html, body").animate({scrollTop: distance });
        }, 200);
    });

    $(window).on("load", function () {

        setTimeout(() => {
            for (let i = 0; i < $personInfoBlocks.length; i++) {

                if (maxHeight < $($personInfoBlocks[i]).innerHeight()) {
                    maxHeight = $($personInfoBlocks[i]).innerHeight();
                }

                if (i === $personInfoBlocks.length - 1) {
                    for (let j = 0; j < $personInfoBlocks.length; j++) {
                        $($personInfoBlocks[j]).css({
                            "height": maxHeight + "px"
                        });
                    }
                }
            }
        },0);
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/personMobNav.js